export { wrapRootElement } from '@greythr/shared-store/wrapper';
import { installPersistentUrlParams } from "@greythr/shared-components/gatsby/persistent-url-params";
import "@fontsource/open-sans";
import "@fontsource/open-sans/500.css";
import "@fontsource/open-sans/600.css";
import "@fontsource/open-sans/700.css";
import "@fontsource/poppins";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";

export const onRouteUpdate = ({ location }) => {
  if (typeof window === "undefined") return;

  if (typeof window.SalesforceInteractions !== "undefined") {
    window.SalesforceInteractions.init()
      .then(() => {
        if (!localStorage.getItem("visitedBefore")) {
          localStorage.setItem("visitedBefore", "true");
        }
        const params = new URLSearchParams(window.location.search);
        if (window.SalesforceInteractions.sendEvent) {
          window.SalesforceInteractions.sendEvent({
            action: "Page View",
            attributes: {
              pageURL: window.location.href,
              pageTitle: document.title,
              deviceType: /Mobi/.test(navigator.userAgent)
                ? "Mobile"
                : "Desktop",
              referrer: document.referrer || "",
              utm_source: params.get("utm_source") || "",
              utm_medium: params.get("utm_medium") || "",
              utm_campaign: params.get("utm_campaign") || "",
              isReturningVisitor: !!localStorage.getItem("visitedBefore"),
            },
            user: {
              identifiers: {
                id:
                  window.userId ||
                  window.SalesforceInteractions.getAnonymousId(),
                email: window.userEmail || null,
              },
              attributes: {
                firstName: window.userFirstName || "Unknown",
                country: window.userCountry || "unknown",
                deviceType: /Mobi/.test(navigator.userAgent)
                  ? "Mobile"
                  : "Desktop",
                isReturningVisitor: !!localStorage.getItem("visitedBefore"),
              },
            },
          });
          console.log("Salesforce Page View Event Sent:", location.pathname);
        }
      })
      .catch((error) => {
        console.warn("MCP init failed:", error);
      });
  }
  if (window.dataLayer) {
    window.dataLayer.push({ event: "optimize.activate" });
  }
  //Below lines are for AC site tracking.
  if (window.vgo) {
    window.vgo("update");
  }
  //Below lines of codes are for calling generic gatsby route changed event handler which is inserted to SPA
  //Through GTM tag "Gatsby Route Changed Event Handler".
  if (window.gatsbyRouteChangedEventHandler) {
    window.gatsbyRouteChangedEventHandler();
  }
};

export const onInitialClientRender = () => {
  installPersistentUrlParams();
};

// Disable Gatsby prefetch for cross-app routes (resource & wiki sites)
// so the main site's loader doesn't try to load their component chunks.
export const disableCorePrefetching = () => true;

export const onPrefetchPathname = ({ pathname, loadPage }) => {
  if (
    pathname.startsWith("/resources/") ||
    pathname.startsWith("/wiki/")
  ) {
    return;
  }

  loadPage(pathname);
};
